import { QueryClient } from "react-query"
import { UseSearchOptions, SalesWatchFilters } from "./hooks/useSearch"
import { generateQueryParams } from "./queryParams"
import { SalesWatch, SeoWatch } from "../types"

export const queryClient = new QueryClient()

export const API_BASE_URL = process.env.GATSBY_API_BASE_URL

export const getSearchResults = (query: string, options: UseSearchOptions) => {
  const queryParams = generateQueryParams(query, options)

  return fetch(
    `${API_BASE_URL}/elastic_watches?${queryParams.toString()}`
  ).then(res => res.json())
}

export type SortingTypes =
  | "null"
  | "price_asc"
  | "price_desc"
  | "createdAt_desc"

export const getSalesWatches = (
  filters: SalesWatchFilters,
  sorting: SortingTypes
) => {
  const options = {
    page: filters.page,
    limit: filters.limit,
    filters: {
      brandName: filters.brandName,
      gender: filters.gender,
      movement: filters.movement,
      watchCondition: filters.watchCondition,
      modelName: filters.modelName,
    },
    sorting,
  }
  const queryParams = generateQueryParams("", options)

  return fetch(
    `${API_BASE_URL}/sales_watches?${queryParams.toString()}&active=true`
  ).then(res => res.json())
}

export const getSalesWatch = (
  id: number | null,
): Promise<SalesWatch | null> => {
  if (!id) {
    return Promise.reject(new Error("Sales watch ID is required"))
  }

  return fetch(
    `${API_BASE_URL}/sales_watches/${id}?active=true`
  ).then(res => res.json())
}

export const getMagazines = (options: UseSearchOptions) => {
  const queryParams = generateQueryParams("", options)
  queryParams.append("type", "magazine")

  return fetch(`${API_BASE_URL}/magazines?${queryParams.toString()}`).then(
    res => res.json()
  )
}

export const getSeoWatch = (
  id: number | null,
): Promise<SeoWatch | null> => {
  if (!id) {
    return Promise.reject(new Error("Sales watch ID is required"))
  }

  return fetch(
    `${API_BASE_URL}/seo_watches/${id}`
  ).then(res => res.json())
}
